export const UPDATE_PERSON = 'personIdentifiedPage/UPDATE_PERSON';
export const UPDATA_OTHER_PARAM_DATA = 'personIdentifiedPage/UPDATA_OTHER_PARAM_DATA';
const initialState = {
    person:{

        idTypeOption:[{ "v": "居民身份证", "k": 1}, { "v": "军(警)身份证", "k": 31}, { "v": "工作居住证或暂住证", "k": 2}, { "v": "香港居民身份证", "k": 10}, { "v": "澳门居民身份证", "k": 16}, { "v": "护照", "k": 3}, { "v": "台胞证", "k": 7}, { "v": "来往大陆通行证", "k": 8}, { "v": "旅行证", "k": 19}, { "v": "军官证", "k": 4}, { "v": "军官退休证", "k": 18}, { "v": "警官证", "k": 11}, { "v": "警官退休证", "k": 20}, { "v": "文职干部证", "k": 32}, { "v": "文职干部退休证", "k": 14}, { "v": "士兵证", "k": 15} , { "v": "其他", "k": 99}],
        owner_cert_img:[],
        isLoad1:0,
        realName:'',
        idTypeText:'',
        idNo:'',
        isAuthed:false,
    },
    otherParm:{
        imgSrc:""
    }


};

const personReducer =  (personData={}, action)=>{
    switch (action.type) {
        case UPDATE_PERSON:
            return {
                ...personData,
                [action.subType]:action.data
            };
        default:
            return personData
    }
}
const otherParmReducer =  (otherParm={}, action)=>{
    switch (action.type) {
        case UPDATA_OTHER_PARAM_DATA:
            return {
                ...otherParm,
                [action.subType]:action.data
            };
        default:
            return otherParm
    }
}
export default (state = initialState, action) => {
    return {
        person : personReducer(state.person, action),
        otherParm : otherParmReducer(state.otherParm, action),
    };
}

export const dispatch_func = {
    update_person : (data,type) => {
        return dispatch => {
            dispatch({
                type: UPDATE_PERSON,
                subType:type,
                data: data
            });
        };
    },
    update_otherParmData : (data,type) => {
        return dispatch => {
            dispatch({
                type: UPDATA_OTHER_PARAM_DATA,
                subType:type,
                data: data
            });
        };
    },
};



// WEBPACK FOOTER //
// ./src/modules/personIdentifiedPage.js